import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const ForeverAlive = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - FOREVER ALIVE</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - FOREVER ALIVE</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Verse 1: GAUSH]<br/>
                Forever alive, mere marne ke baad bane mere holograms<br/>
                They pehele nai dekhte, ab utru jab stage se they click karte photographs<br/>
                Aaya mai TV par, jeeta ek league then I go on vacations<br/>
                The best in the game, and I'm destined for greatness there's no conversations<br/>
                Hu mai jahase nai aana yahape agar aakhe milaale tu<br/>
                To kardete khaatme, kuch nai m&#1077;re haath me sunle t&#1077;ri maa ki ***<br/>
                Kaisi ladayi seedhe kardu tabah inhe baat samajh aati nai<br/>
                Mat dena safayi unko maana tha bhai kyu tum vaade nibhaate nai kyu?<br/>
                Baat sun<br/>
                Kyu banate<br/>
                Ye fisool ki baate<br/>
                Bhardu ghoose laate<br/>
                Seedhe moo pe aake<br/>
                Mai rakhu ye vaade<br/>
                Mere crew ke naam pe<br/>
                Jara sun<br/>
                Dhyaanse<br/>
                Bache kuch din abhi<br/>
                Bade mushkilo ke<br/>
                Baad bhi umeed nahi<br/>
                Chodi maine<br/>
                2 din pehele 6 figures jode maine<br/>
                Man I flex<br/>
                <br/>
                [Chorus: GAUSH &amp; Notion XIX]<br/>
                Forever Alive Forever Alive ain't nobody stopping us<br/>
                Forever Alive Forever Alive ain't nobody stopping us<br/>
                Forever Alive, hai jalte jo bande wo sabhi hai crooks<br/>
                Forever Alive, ain't nobody stopping us ever, it's true<br/>
                <br/>
                [Verse 2: Notion XIX]<br/>
                Baate bandh<br/>
                Jabhi se hai baje unn speakers par<br/>
                Hai maare inn ladko ko faate par<br/>
                Hai pura hi gang unstoppable<br/>
                Hai Tera jo clout wo likha hua chalk me<br/>
                Dabega aaj in pairo ke bal<br/>
                Rukta nai mai ab unn choti si baato par<br/>
                Tabhi toh hote jazbaate ye clutch<br/>
                Girenge sab<br/>
                Farzi dikhave, hai nakli wo glow, aur hai<br/>
                Farzi wo baate hai, jaise wo joote, when<br/>
                Shining on clout w that Nike Air faux<br/>
                Launde Ye baaz nai aate hai<br/>
                Bandi ke naam pe ye karte ab grow<br/>
                Fuck all that noise, y'all ain't better than crows<br/>
                Hai fir bhi mazaak, wo nai le paate jokes<br/>
                Ladke ye baaz nai aate hai<br/>
                Tabhi aaj<br/>
                Udte ye close, hai behti aag<br/>
                Kaafi jo dil me, no demigods<br/>
                And they keep on talking, we kill em all<br/>
                Wo baate hai dumb<br/>
                Hai songs pe haath wo versatile<br/>
                You know those words fall precise<br/>
                Level up all the way, need a sign<br/>
                I'm Feeling alive, Forever alive<br/>
                <br/>
                [Chorus: GAUSH &amp; Notion XIX]<br/>
                Forever Alive Forever Alive ain't nobody stopping us<br/>
                Forever Alive Forever Alive ain't nobody stopping us<br/>
                Forever Alive, hai jalte jo bande wo sabhi hai crooks<br/>
                Forever Alive, ain't nobody stopping us ever, it's true<br/>
                Forever Alive Forever Alive ain't nobody stopping us<br/>
                Forever Alive Forever Alive ain't nobody stopping us
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default ForeverAlive;
